import { jwtDecode } from "jwt-decode"

import type { DecodedAccessToken, DecodedIdToken, TokenUser } from "@/types/auth"

export const parseJwtToken = function (
  idToken: string | null | undefined,
  accessToken: string | null | undefined
): TokenUser | null {
  if (!idToken || !accessToken) return null

  try {
    const decodedIdToken = jwtDecode<DecodedIdToken>(idToken)

    const decodedAccessToken = jwtDecode<DecodedAccessToken>(accessToken)

    return {
      id: decodedIdToken["cognito:username"],
      oldId: decodedIdToken["custom:as400_id"],
      role: decodedIdToken["custom:Role"],
      avatarUrl: decodedIdToken["custom:avatar_url"] ?? undefined,
      fullName: decodedIdToken.name,
      email: decodedIdToken.email,
      isActive: decodedAccessToken.isActive === undefined ? true : decodedAccessToken.isActive,
    }
  } catch (error) {
    console.error("Failed to decode tokens:", error)
    return null
  }
}
